import React, { useRef } from "react";
import FileIcon from "../../utility/Attach_doc/file.png";
import { AiFillDelete } from "react-icons/ai";
import "./Attach.css";
import deleteicon from '../../assets/delete-transformed.png'

const AttachmentGrid = ({ attachments = [], onDocClick, onFileSelect, onDelete }) => {

  const fileInputRef = useRef(null);

  const handleAddClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onFileSelect) {
      onFileSelect(file);
    }
  };

  return (
    <div className="attachmentSection">
      <p className="attachTitle">Attachments</p>

      <div className="row" style={{ width: "100%", height:"50vh", overflowY:"auto", paddingBottom:"20vh" , scrollbarWidth:"none"}}>
        
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        <div
          className="col-md-4"
          style={{
            padding: "10px 5px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="addAttachment"
            onClick={handleAddClick}
            style={{
              cursor: "pointer",
              height: "90px",
              backgroundColor:"#eee",
              width: "90px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "60px",
              borderRadius: "50%"
            }}
          >
            +
          </div>
        </div>

       
        {attachments.map((doc) => (
          <div
            className="col-md-4"
            key={doc.attachmentid}
            style={{
              padding: "10px 5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="docdivv" style={{ cursor: "pointer", position:"relative" }}>
              <div
  style={{
    position: "absolute",
    top: "5px",
    right: "20px",
    color: "white",
    fontSize: "14px",
    cursor: "pointer",
    backgroundColor: "red",
    zIndex: 10,
    borderRadius: "50%",
    width: "25px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.4)"
  }}
>
  <img
    onClick={(e) => {
      e.stopPropagation();
      onDelete?.(doc);
    }}
    src={deleteicon}
    style={{
      width: "15px",
      filter: "invert(1)"
    }}
  />
</div>
            

              <div className="main" onClick={() => onDocClick?.(doc)}>
                <img src={FileIcon} alt="" />

                <span style={{ fontSize: "10px" }}>
                  {doc.extension}
                </span>
              </div>

              <div className="bottom">
                <span className="docname">{doc.filename}</span>
              </div>

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default AttachmentGrid;